'use client'

import type { ComponentType } from 'react'
import type { CalculatorProps } from './types'

import Calculator from './Calculator'
import CalculatorCCSP from './CalculatorCCSP'
import CalculatorEducationPFi from './CalculatorEducationPFi'
import CalculatorMicroPFi from './CalculatorMicroPFi'
import CalculatorMotorcycle from './CalculatorMotorcycle'
import CalculatorProfessionalPFi from './CalculatorProfessionalPFi'
import CalculatorTD from './CalculatorTD'
import CalculatorUmrah from './CalculatorUmrah'

export type { CalculatorProps }

/**
 * Calculators are client components. A Server Component cannot pass one as a
 * prop — component references are not serializable across the RSC boundary, and
 * doing so pulls the client module into the server graph (`createContext is not
 * a function` at build time). Server callers pass one of these string keys
 * instead and the client component resolves it here.
 */
export const CALCULATOR_VARIANTS = {
  default: Calculator,
  ccsp: CalculatorCCSP,
  microPFi: CalculatorMicroPFi,
  motorcycle: CalculatorMotorcycle,
  professional: CalculatorProfessionalPFi,
  education: CalculatorEducationPFi,
  td: CalculatorTD,
  umrah: CalculatorUmrah
} satisfies Record<string, ComponentType<CalculatorProps>>

export type CalculatorVariant = keyof typeof CALCULATOR_VARIANTS
